import { render } from "./_form-input.vue?vue&type=template&id=108b06fc"
import script from "./_form-input.vue?vue&type=script&lang=js"
export * from "./_form-input.vue?vue&type=script&lang=js"

import "./_form-input.vue?vue&type=style&index=0&id=108b06fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__